module.exports = __webpack_public_path__ + "static/img/ee.8966b416.svg";